import { useEffect, useState } from "react";
import type { Observable } from "rxjs";
import { useFutureCallback } from "./useFutureCallback";

/** Use the response data from an observable, updating the state as the observable provides new
 * values. */
export const useObservable = <T,>(
  getter: () => Observable<T>,
  deps?: React.DependencyList
): { data: T | undefined; loaded: boolean } => {
  const [data, setData] = useState<T | undefined>(undefined);
  const [loaded, setLoaded] = useState<boolean>(false);

  const stableGetter = useFutureCallback(getter);

  useEffect(() => {
    const subscription = stableGetter().subscribe((value) => {
      setLoaded(true);
      setData(value);
    });

    return () => subscription.unsubscribe();
  }, [
    stableGetter,
    ...(deps ?? []), // eslint-disable-line react-hooks/exhaustive-deps
  ]);

  return { data, loaded };
};
